module.exports = __webpack_public_path__ + "img/content_null.d855e50c.png";